import ConfirmDialogComponent from "./ConfirmDialog";
import Vue from "vue";
import vuetify from '../../plugins/vuetify';

export default {
  open(message, confirm,cancel) {
    let propsData = {
      visible: true,
      message: message,
      confirm: confirm,
      cancel: cancel
    };
    const cd = Vue.extend(ConfirmDialogComponent);
    this.component = new cd({
      el: document.createElement("div"),
      vuetify,
      propsData
    });
  },

  close() {
    this.component.close();
  }
};
